<template>
    <div class="sing-in">
        <b-form @submit="passwordReset" class="sing-in-form  text-center">
            <h3  class="title">Reset Password</h3>
            <b-form-input type="email" v-model="email" placeholder="Your email" required></b-form-input>

            <div class="d-flex">
              <div>
                <router-link
                  class="link"
                  :to="{name: 'singin'}"
                >
                  Sign in
                </router-link>
              </div>
              <div class="ml-auto">
                <b-button
                  class="button ml-auto"
                  type="submit"
                  variant="primary"
                >
                  Send
                </b-button>
              </div>
            </div>
        </b-form>
    </div>
</template>

<script>

export default {
  name: 'PasswordReset',
  data () {
    return {
      email: ''
    }
  },
  methods: {
    passwordReset (e) {
      e.preventDefault()
      this.axios
        .post('/api/password/reset', {
          email: this.email
        })
        .then(response => {
          console.log(response)
          this.$snotify.success(response.data.massage, 'Success', this.$store.state.snotify)
          this.email = ''
        })
        .catch(err => {
          this.$snotify.error(err.response.data.error, 'Error', this.$store.state.snotify)
          console.log(err)
        })
    }

  }
}
</script>

<style scoped>
.sing-in{
  display: flex;
  justify-content: center;
}
    .sing-in-form{
        width: 320px;
    }

    .sing-in-form h3{
        margin-bottom: 20px;
    }

    .sing-in-form input{
        margin-bottom: 20px;
    }

</style>
